import { Button, message } from 'antd';
import { FC } from 'react';

import { AuditLogger } from 'src/utils/audit-logger';
import { parseIfObject } from 'src/utils/common';
import { FirebaseManager } from 'src/utils/firebase/firebase-manager';

import AddProductToListModal from 'src/atomic-components/organisms/Modals/AddProductToListModal';

import classes from './FavoriteProductsEditCell.module.scss';

const firebaseManager = FirebaseManager.getInstance();
const auditLogger = AuditLogger.getInstance();
const logName = '사용자 관리';

interface FavoriteProductsEditCellProps {
  userId: string;
  userLabel: string;
  currentIds: string[];
  onSaved: (ids: string[]) => void;
}

const FavoriteProductsEditCell: FC<FavoriteProductsEditCellProps> = ({ userId, userLabel, currentIds, onSaved }) => {
  const handleSave = async (ids: string[]) => {
    try {
      await firebaseManager.updateDoc('user', userId, { favoriteProducts: ids }, { audit: { suppress: true } });
      auditLogger.log({
        action: 'UPDATE',
        entity: 'user',
        entityId: userId,
        summary: `${logName} - 즐겨찾기 수정 (${userLabel})`,
        changes: [{ field: 'favoriteProducts', before: currentIds, after: ids }],
      });
      onSaved(ids);
      message.success('즐겨찾기를 저장했습니다.');
    } catch (error: any) {
      auditLogger.log({
        action: 'UPDATE',
        entity: 'user',
        entityId: userId,
        summary: `${logName} - 즐겨찾기 수정 실패 (${userLabel}): ${parseIfObject(error)}`,
        level: 'error',
      });
      throw error;
    }
  };

  return (
    <div className={classes.cell}>
      <span className={classes.count}>{currentIds.length}개</span>
      <AddProductToListModal
        mode='staged'
        title='즐겨찾기 편집'
        showCurrentList
        enableReorder
        currentProductIds={currentIds}
        onSave={handleSave}
        openButton={
          <Button size='small' type='link'>
            편집
          </Button>
        }
      />
    </div>
  );
};

export default FavoriteProductsEditCell;
